<p>tools-usage-chart works!</p>
<div id="toolsUsageChartDiv"></div>
